import { headerAndFooter } from '@config';

module.exports = function (S) {
  INKIVE.isNewDesign = true;
  const canvas = S.canvas;
  const getNextId = S.getNextId;

  let oldSelectedElems = [];

  function recalculatePopupMenuScrollHandler (opts) {
    opts = opts || {};
    const $elementPopupmenu = $('.element-popupmenu.menu');
    const $leftArrow = $elementPopupmenu.siblings('.scroll-handler-left').hide();
    const $rightArrow = $elementPopupmenu.siblings('.scroll-handler-right').hide();
    const safeWidth = 3;
    const menuWidth = $elementPopupmenu.outerWidth();
    const width = $elementPopupmenu.parent().width();

    if (!width || (menuWidth >= width - safeWidth && menuWidth <= width + safeWidth)) return;

    opts.skipScroll || $elementPopupmenu.css('left', 0);

    if (opts.showBoth) {
      $leftArrow.fadeIn('slow');
      $rightArrow.fadeIn('slow');
    } else {
      (opts.$handler || $rightArrow).fadeIn('slow');
    }
  }

  function isHeaderAndFooterEnabled () {
    return [
      headerAndFooter.main.layer,
      headerAndFooter.header.layer,
      headerAndFooter.footer.layer
    ].includes(canvas.getCurrentLayerName());
  }

  return {
    selectedChanged: function () {
      const mode = canvas.getMode();
      const $svgroot = $('#svgroot');
      canvas.validateSelectedElems();

      const elems = canvas.getSelectedElems();

      if (
        elems.length &&
        oldSelectedElems.length === elems.length &&
        oldSelectedElems.every((value, index) => value === elems[index])
      ) {
        return;
      }

      oldSelectedElems = elems.slice();
      const length = elems.length;

      // show root menu after unselect
      if (!elems || !length) {
        const bleed = canvas.runExtensions('getBleedValues', {});

        if (bleed.manage) {
          canvas.runExtensions('showBleedPopupMenu');
        } else if (INKIVE.Menus.elementPopupMenu && !isHeaderAndFooterEnabled()) {
          $svgroot.popupmenu().length || INKIVE.Menus.elementPopupMenu.render($svgroot, 'root');
          $svgroot.popupmenu().length && INKIVE.Menus.elementPopupMenu.hide();
        }
      } else if ($.inArray(mode, ['select', 'textedit', 'multiselect', 'table-edit']) >= 0) {
        $(elems).removeClass('subelement');

        const skipRender = elems.length === 1 && $(elems).popupmenu().length;

        if (!skipRender) {
          const render = () => {
            if (!INKIVE.Menus.elementPopupMenu ||
              (!INKIVE.FontsFactory.fontListLoaded && ($(elems[0]).is('.textarea')))) {
              setTimeout(render, 100);
            } else {
              INKIVE.Menus.elementPopupMenu.render(elems);
            }
          };
          render();
        }
        // Not just grouped text
        if (($(elems[0]).children().hasClass('textarea') && ($(elems[0]).find('>:not(g.textarea)').length || $(elems[0])
          .is('.sticker'))) ||
          $(elems[0]).children().hasClass('layoutBox')) {
          $(elems[0]).find('.textarea, .layoutBox').each(function (i, subelement) {
            $(subelement).addClass('subelement');
            if (!$(subelement).attr('id')) {
              $(subelement).attr('id', getNextId());
            }
          });
        }
      }
    },

    // Change mode
    clear: function (opts) {
      const that = this;
      const $placeholder = opts.elems
        ? $(opts.elems[0]).find('.layoutBox.subelement')
        : null;
      const mode = canvas.getMode();

      if (mode === 'textedit' || mode === 'table-edit') {
        that.selectedChanged();
      } else if ($placeholder && $placeholder.length) {
        $placeholder.each(function () {
          that.selectedChanged();
        });
      } else if (INKIVE.Menus.elementPopupMenu) {
        INKIVE.Menus.elementPopupMenu.$el.children().length || this.selectedChanged(opts);
      }
    },

    mouseMove: function () {
      // INKIVE.C.IS_MOBILE || canvas.getMode() === 'select' && INKIVE.Menus.elementPopupMenu.hide();
    },

    mouseDown: function (opts) {
      if (!_.includes(['select', 'multiselect'], canvas.getMode())) {
        return;
      }

      /*
      const $banner = $(opts.event.target).parents('.textarea.subelement');

      if ($banner.length) {
        INKIVE.Menus.elementPopupMenu.render([$banner.get(0)], 'text');
      } else */
      if (!INKIVE.C.IS_MOBILE) {
        this.selectedChanged(opts);
      }
    },
    mouseUp: function (opts) {
      if (!_.includes(['select', 'multiselect'], canvas.getMode())) {
        return;
      }

      let x,
        y;
      if (opts.event.changedTouches && opts.event.changedTouches.length) {
        x = opts.event.changedTouches[0].pageX;
        y = opts.event.changedTouches[0].pageY;
      } else {
        x = opts.event.clientX;
        y = opts.event.clientY;
      }

      const isClickInside = INKIVE.Tool.getInstance().editor.isClickInsideEditor(x, y);

      if (!canvas.getSelectedElems().length && opts.mouse_target.id === 'svgroot' && isClickInside) {
        const bleed = canvas.runExtensions('getBleedValues', {});
        if (bleed.manage) return;

        if (!isHeaderAndFooterEnabled()) {
          return canvas.runExtensions('showBackgroundPopupMenu');
        } else if (canvas.getCurrentLayerName() === headerAndFooter.main.layer) {
          return canvas.runExtensions('showHeaderAndFooterMenu');
        } else {
          return INKIVE.EditorFacade.handle('header_and_footer', 'open', {
            type: 'headerAndFooter'
          });
        }
      }
    },

    reloadFontLocaleSubset: function (localeSubset) {
      if (!localeSubset) return;
      const $elem = $(INKIVE.EditorFacade.canvas.getSelectedElems()[0]);
      $elem.data('font-locale-subset', localeSubset);

      INKIVE.EditorFacade.canvas.clearSelection();
      INKIVE.EditorFacade.canvas.selectOnly($elem);
      _.defer(function () {
        $('[data-action=on_fontfamily]').trigger('mousedown').trigger('click');
      });
    },

    browserResize: function (opts) {
      recalculatePopupMenuScrollHandler(opts);
    }
  };
};
